import { useState } from "react";

export const useApiResponseHandler = () => {
    const [showAlertPopupModal, setShowAlertPopupModal] = useState(false);
    const [alertPopupModalData, setAlertPopupModalData] = useState({
        title: "Attention required",
        message: "Something went wrong",
    });

    const [showErrorPopupModal, setShowErrorPopupModal] = useState(false);
    const [errorPopupModalData, setErrorPopupModalData] = useState({
        title: "Opps! An error occurred",
        message: "Something went wrong",
    });

    const handleResponseCode = (response) => {
        const code = response?.Data?.ResponseCode;
        const message =
            response?.Data?.ErrorMessage ||
            response?.Data?.Message ||
            "Something went wrong";

        // ✅ SESSION EXPIRED
        if (code === 401) {
            sessionStorage.clear();
            localStorage.clear();

            window.location.href = "/"; // redirect to login
            return { success: false, code, message };
        }
        const successCodes = [200, 447, 448, 1555];

        const errorPopupCodes = [
            404, 405,406,       // 406- Please enter a last name
            408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422,
            424, 425, 426, 427,
            430, 431, 432, 433, 434, 435,
            38, 475
            ,486 // for New Booking> On Spot Filter - You already have a space booked for that day!
        ];

        const alertCodes = [407, 423];  // 485 ["ErrorMessage":"You have already submitted your follow-up questions"] to be add or not -by Jahanvi- confirm with Akash

        // ✅ SUCCESS → NO POPUP
        if (successCodes.includes(code)) {
            return { success: true, code, message };
        }

        // ✅ ERROR POPUP LIST
        if (errorPopupCodes.includes(code)) {
            setErrorPopupModalData({
                title: "Opps! An error occurred",
                message
            });
            setShowErrorPopupModal(true);
            return { success: false, code, message };
        }

        // ✅ ALERT POPUP LIST
        if (alertCodes.includes(code)) {
            setAlertPopupModalData({
                title: "Attention required",
                message
            });
            setShowAlertPopupModal(true);
            return { success: false, code, message };
        }

        // ✅ DEFAULT → ERROR POPUP
        setErrorPopupModalData({
            title: "Opps! An error occurred",
            message
        });
        setShowErrorPopupModal(true);

        return { success: false, code, message };
    };


    return {
        handleResponseCode,
        showAlertPopupModal,
        alertPopupModalData,
        showErrorPopupModal,
        errorPopupModalData,
        setShowAlertPopupModal,
        setShowErrorPopupModal
    };
};
